import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'rt-placement-row',
  templateUrl: 'placement-row.component.html',
  styleUrls: ['placement-row.component.less'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    layout: '',
    'layout-full-width': '',
  },
})
export class PlacementRowComponent {}
